
export default [
  {
    path: '/dashboard/specials',
    name: 'EtalonSpecialList',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/Etalon/Specials/SpecialListView.vue')
  },
  {
    path: '/dashboard/specials/create',
    name: 'EtalonSpecialCreate',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/Etalon/Specials/SpecialCreateView.vue')
  },
  {
    path: '/dashboard/specials/:id/edit',
    name: 'EtalonSpecialEdit',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/Etalon/Specials/SpecialEditView.vue')
  }
]
